<studio-button-legacy [theme]="theme" [attr.title]="tooltip">
  <studio-icon [name]="active ? iconActive : iconInactive"></studio-icon>
</studio-button-legacy>
